import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Entity } from '../../models/entity.class';
import { Record } from '../../models/record/record.class';

@Component({
    selector: 'app-multiple-record-edit',
    templateUrl: './multiple-record-edit.component.html',
    styleUrls: ['./multiple-record-edit.component.scss'],
    standalone: false,
})
export class MultipleRecordEditComponent implements OnInit {
    public detailsForUpdate: { records: Record[]; record: Record };
    public service: any;
    public entity: Entity;
    public instanceId: string;
    public recordInputModelChange: Function;
    public submitRecord: Function;
    public masterEntityFieldValueMap = {};
    public fieldsMap: BehaviorSubject<{
        [property: string]: {
            keyColumns: string[];
            valuesMap: {
                id: string;
                entityId: string;
                masterColumn: string;
                value: any;
                references: any[];
            }[];
        };
    }> = new BehaviorSubject(undefined);
    public recordIds: string[];
    public parentRecordId: string;

    constructor() {}

    ngOnInit(): void {}
}
